/* eslint-disable import/prefer-default-export */
export const isArray = (elm) =>
  Object.prototype.toString.call(elm) === '[object Array]' || elm.constructor.name === 'Array';
